<template>
	<div id="app" ref="app">
		<router-view></router-view>
    <dialog-dom></dialog-dom>
    <search-dialog></search-dialog>
    <pre id="dynamic-hide-label" style=" font-family: inherit;display: inline-block;position: fixed;position: fixed;visibility:hidden;top: 100px;right: 200px;font-size: 12px;padding-left: 2px;padding-right: 2px"></pre>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { checkSession } from '@/api/common.js'
  export default{
    name: 'APP',
    computed: {
      ...mapGetters([
        'checkSessionUrl'
      ])
    },
    created() {
      // console.log(process.env.PROJECT)
      const _this = this
      this.$router.beforeEach(function(to, from, next) {
        // _this.$nextTick(() => {
        //   // var App = document.getElementById('app')
        //   if (process.env.PROJECT === 'dealer_pc') {
        //     var dialog = document.getElementsByClassName('dialog_class')[0]
        //     var vModal = document.getElementsByClassName('v-modal')[0]
        //     console.log(dialog)
        //     console.log(dialog.style.display)
        //     if (dialog && (dialog.style.display === 'block'|| window.getComputedStyle(dialog,null)['display'] === 'block')) {
        //         dialog.style.display = 'none'
        //         vModal.style.display = 'none'
        //     }
        //   }
        // })
        if (process.env.PROJECT === 'dealer_pc') {
          _this.$eventBus.$emit('searchDialogHide')
        }
        console.log(process.env.PROJECT)
        const keyPath = to.path
        _this.$store.dispatch('addVisitedMap', {
          key: keyPath,
          val: from,
          query: to.query
        })
        next()
      })
    },
    mounted() {
      // this.$refs.app.addEventListener('copy', (e) => {
      // this.addCopyMessage(e)
      // })
    //  const app = document.querySelector('#app')
    //  app.addEventListener('copy', (e) => {
    //    this.addCopyMessage(e)
    //  })
    },
    watch: {
      '$route'(to, from) {
        if (this.checkSessionUrl) {
          checkSession(this.checkSessionUrl).then(res => {
            // this.$message.error(this.$t('lang.checkSession_faile'))
          })
        }
      }
    },
    methods: {
      addCopyMessage(e) {
        if (process.env.PROJECT === 'bi') {
          var clipboardData = event.clipboardData || window.clipboardData
          if (!clipboardData) { return }
          var text = window.getSelection().toString()
          if (text) {
            event.preventDefault()
            if (process.env.NODE_ENV === 'production') {
              clipboardData.setData('text/plain', '版权为北京惠赢天下网络技术有限公司所有。\n 如有需要请联系本公司: 400-687-0066')
            } else {
              clipboardData.setData('text/plain', '如需调试请联系我')
            }
          }
        }
      }
    }
  }

</script>
<style type="text/css">
  /* 滚动条 */
  ::-webkit-scrollbar-thumb:horizontal { /*水平滚动条的样式*/
    width: 4px;
    background-color: #CCCCCC;
    -webkit-border-radius: 6px;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }
  ::-webkit-scrollbar {
    width: 10px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb:vertical { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #999;
    -webkit-border-radius: 4px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
  }
  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #9f9f9f;
    -webkit-border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue